import { IconNames } from '@blueprintjs/icons';
import { ActionButtonText } from '@strata/react-buttons';
import { type ReactNode, useState } from 'react';

interface AdditionalFieldsProps {
    title: string;
    children: ReactNode;
}

export const AdditionalFields = ({ title, children }: AdditionalFieldsProps) => {
    const [isHidden, setIsHidden] = useState(true);

    return isHidden ? (
        <ActionButtonText
            leftIcon={IconNames.ADD}
            label={`Show Additional ${title} Fields`}
            onClick={() => setIsHidden(false)}
        />
    ) : (
        (children as JSX.Element)
    );
};
